export enum TrafficSource {
	CadacInternal = 'cadac_internal',
	CadacExternal = 'cadac_external',
	General = 'general',
}
